module.exports = __webpack_public_path__ + "static/media/check-pink.08201959.svg";